import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '@sparro/app/material.module';

import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
import { EmbedVideoDialogComponent } from './embed-video-dialog/embed-video-dialog.component';
import { JournalEditRouterComponent } from './journal-edit-router/journal-edit-router.component';
import { JournalEditRoutingModule } from './journal-edit-routing.module';
import { JournalEditComponent } from './journal-edit/journal-edit.component';
import { JournalHeaderComponent } from './journal-header/journal-header.component';
import { JournalMetaComponent } from './journal-meta/journal-meta.component';
import { RedirectCheckComponent } from './redirect-check/redirect-check.component';
import { ReferenceDialogComponent } from './reference-dialog/reference-dialog.component';
import { UploadMediaComponent } from './upload-media/upload-media.component';

import { NavigationButtonComponent } from '@sparro/app/shared/components/buttons/blueprints/navigation-button/navigation-button.component';
import { ButtonsModule } from '@sparro/app/shared/components/buttons/buttons.module';
import { DialogModule } from '@sparro/app/shared/components/dialogs/dialog.module';
import { SnackbarDisplayComponent } from '@sparro/app/shared/components/dialogs/snackbar-display/snackbar-display.component';
import { LayoutModule } from '@sparro/app/shared/components/layout/layout.module';
import { LoaderModule } from '@sparro/app/shared/components/loader/loader.module';
import { UploaderModule } from '@sparro/app/shared/components/uploader/uploader.module';
import { EmbedVideo } from 'ngx-embed-video';
import { ImagesModule } from '@sparro/app/shared/components/images/images.module';
import { AiEditsComponent } from './ai-edits/ai-edits.component';

@NgModule({
  declarations: [
    JournalEditComponent,
    JournalHeaderComponent,
    JournalEditRouterComponent,
    RedirectCheckComponent,
    ReferenceDialogComponent,
    EmbedVideoDialogComponent,
    UploadMediaComponent,
    JournalMetaComponent,
    AiEditsComponent
  ],
  entryComponents: [
    ReferenceDialogComponent,
    EmbedVideoDialogComponent,
    NavigationButtonComponent,
    SnackbarDisplayComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    ReactiveFormsModule,
    FormsModule,
    FlexLayoutModule,
    JournalEditRoutingModule,
    FroalaViewModule,
    FroalaEditorModule,
    EmbedVideo.forRoot(),
    LoaderModule,
    ButtonsModule,
    LayoutModule,
    UploaderModule,
    DialogModule,
    ImagesModule
  ],
  exports: [AiEditsComponent]
})
export class JournalEditModule {}
